import shopet from '../images/shopet.jpg'
import plusworld from "../images/plusworld.png"
import audet from "../images/audet.png"
import afroroyals from "../images/afroroyals.png"
import adot from "../images/adot.png"

const projects =[   
    {
        id:1,
        name: 'Plusworld',
        link: 'https://plusworld.vercel.app',
        imgSrc: plusworld,
        github:'https://github.com/Afayomide',
        visit:'https://plusworld.vercel.app'
    },
    {
        id:2,
        name: 'Afro Royals',
        link: 'https://afrifashion.vercel.app',
        imgSrc: afroroyals,
        github:'https://github.com/Afayomide/afrifashion',
        visit:'https://afrifashion.vercel.app'
    },
    {
        id:3,
        name:"Audet Blog",
        link:"https://audet.vercel.app",
        imgSrc: audet,
        github: 'https://github.com/Afayomide',
        visit: 'https://audet.vercel.app'
        
    },
    {
        id:4,
        name: 'Adot Advisor',
        link: 'https://adotadvisor.vercel.app',
        imgSrc: adot,
        github:'https://github.com/Afayomide/adotadvisor',
        visit:'https://adotadvisor.vercel.app'
    },

    

    {
        id:5,
        name: 'Shopet',
        link: 'https://shopet-sable.vercel.app',
        imgSrc: shopet,
        github: 'https://github.com/Afayomide/shopet',
        visit: 'https://shopet-sable.vercel.app'

    },
 
]

export default projects